import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { StatusIntegracao } from '@shared/models/status-integracao/status-integracao.model';
import { Usuario } from '@shared/models/usuario/usuario.model';
import { environment } from '../../../environments/environment';
import { statusIntegracoesReducer } from './statusIntegracoes.reducer';
import { userReducer } from './user.reducer';
import { CardImovelGerenciamento, GrupoTrabalho } from '@shared/models/gerenciar-imoveis/gerenciar-imoveis.model';
import { RegistroCalculadora } from '@shared/models/calculadora/calculadora.model';
import { calculadoraReducer } from './calculadora.reducers';
import { gerenciamentoImoveisReducer } from './gerenciamento-imoveis.reducer';
import { SmartLinkState, smartLinkReducer } from './smart-link.reducer';
export interface CalculadoraState {
  selectedSimulacoesCalculadora: RegistroCalculadora[];
  simulacoesListagem?: RegistroCalculadora[]; // TODO - Ao adicionar na listagem, tb adicionar na view (antes de adicionar na view, checar se já não existe lá)
  simulacoesView?: RegistroCalculadora[]; // TODO - Ao adicionar na view, não adicionar na listagem
  attemptedSimulacoesSearch: boolean;
}


/**
 * Metadados de paginação por coluna do board (modelo híbrido — Fase 3).
 * Os cards continuam no `allCards` flat; este mapa só guarda quanto há no total
 * por status (servidor) e se a coluna está carregando a próxima página.
 * `hasMore` é derivado no componente: cards carregados da coluna < total.
 */
export interface KanbanColumnMeta {
  total: number;
  loading: boolean;
  /**
   * Cursor de paginação da coluna: nº de cards já consumidos dos endpoints
   * paginados (`/board` inicial + `/board/column`). É o `offset` do próximo
   * load-more. NÃO é incrementado por cards injetados fora da paginação
   * (ex.: deep-link via `upsertDeepLinkedCard`) nem por addCard/reorder — assim
   * o skip/limit do servidor nunca pula nem duplica cards quando há um card
   * trazido por URL antes da sua página natural.
   */
  loadedOffset?: number;
}

export interface GerenciamentoImovelFlowState {
  [flowId: string]: {
    allCards: CardImovelGerenciamento[];
    columns?: { [status: string]: KanbanColumnMeta };
    attemptedSearchCards?: boolean;
    attemptedSearchBoard?: boolean;
    attemptedSearchArquivados?: boolean;
    attemptedSearchEstudoCaso?: boolean;
    /**
     * Ids de cards trazidos por deep-link (`?action=open_dialog&cardId=`) e
     * injetados em `allCards` fora da paginação. Usado para preservá-los quando
     * `setBoardColumns` substitui o `allCards` (race entre `/board` e `/card/:id`).
     */
    deepLinkedCardIds?: string[];
  },
}


export interface GerenciamentoImoveisState {
  cardsGerenciamentoImoveis: GerenciamentoImovelFlowState,
  currentFlowId: string | null;
  gruposTrabalhoState: {
    allGruposTrabalho: GrupoTrabalho[];
    hasInitialLoad: boolean;
  }
}

export interface State {
  user?: Partial<Usuario>;
  statusIntegracoes?: StatusIntegracao[];
  calculadora?: CalculadoraState;
  gerenciamentoImoveis?: GerenciamentoImoveisState;
  smartLink?: SmartLinkState;
}

export const reducers: ActionReducerMap<State> = {
  user: userReducer,
  statusIntegracoes: statusIntegracoesReducer,
  calculadora: calculadoraReducer,
  gerenciamentoImoveis: gerenciamentoImoveisReducer,
  smartLink: smartLinkReducer,
};


export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
